// Get item from localStorage
export function getItem(key) {
  const getLocal = localStorage.getItem(key);
  if (getLocal === null) return null;
  const strItem = String(getLocal);
  try {
    return JSON.parse(strItem); // tempary solution next i will update
  } catch {
    return strItem;
  }
}


// Set item in localStorage
export function setItem(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}
// Remove item from localStorage
export function removeItem(key) {
  localStorage.removeItem(key);
}

// A function to handle all in one (optional)
export function handleStorage(action, key, value = null) {
  switch (action) {
    case 'get':
      return getItem(key);
    case 'set':
      return setItem(key, value);
    case 'delete':
      return removeItem(key);
    default:
      throw new Error(`Unknown action: ${action}`);
  }
}
